import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Blog.css';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const blogs = [
    {
      id: 1,
      title: 'The Future of Web Development in 2024',
      category: 'Technology',
      date: 'March 20, 2024',
      author: 'Suraj Kumar sah',
      excerpt: 'Explore the emerging trends in web development and how they will shape the future of technology.',
      content: 'Web development is rapidly evolving with new frameworks, tools, and methodologies. From AI integration to serverless architecture, the landscape is changing dramatically. In this article, we explore key trends that will dominate web development in 2024 and beyond.',
      image: '📱'
    },
    {
      id: 2,
      title: 'Building Scalable Mobile Applications with Flutter',
      category: 'Mobile',
      date: 'March 15, 2024',
      author: 'Suraj Kumar sah',
      excerpt: 'Learn best practices for building scalable and maintainable mobile applications using Flutter framework.',
      content: 'Flutter has become the go-to framework for cross-platform mobile development. Discover the architectural patterns and best practices that help build scalable applications that perform well on both iOS and Android platforms.',
      image: '📲'
    },
    {
      id: 3,
      title: 'Cloud Infrastructure: AWS vs Azure vs GCP',
      category: 'Cloud',
      date: 'March 10, 2024',
      author: 'Suraj Kumar sah',
      excerpt: 'A comprehensive comparison of major cloud providers and their offerings for modern applications.',
      content: 'Choosing the right cloud provider is crucial for your business. In this detailed comparison, we analyze AWS, Azure, and GCP across various dimensions including pricing, features, and use cases.',
      image: '☁️'
    },
    {
      id: 4,
      title: 'AI Integration in Business: A Practical Guide',
      category: 'AI',
      date: 'March 5, 2024',
      author: 'Suraj Kumar sah',
      excerpt: 'How to effectively integrate artificial intelligence and machine learning into your business operations.',
      content: 'Artificial Intelligence is no longer just a buzzword. Learn how to identify use cases in your business where AI can add value and implement practical solutions using modern AI tools and services.',
      image: '🤖'
    },
    {
      id: 5,
      title: 'Startup Lessons: What I Learned Founding Solutionspath Tech',
      category: 'Entrepreneurship',
      date: 'February 28, 2024',
      author: 'Suraj Kumar sah',
      excerpt: 'Insights and lessons from founding my own technology company and what it takes to succeed.',
      content: 'Starting a tech company is challenging but rewarding. In this post, I share key lessons learned from founding Solutionspath Technology, including team building, product development, and market strategy.',
      image: '🚀'
    },
    {
      id: 6,
      title: 'Database Optimization: Performance Tuning Strategies',
      category: 'Database',
      date: 'February 20, 2024',
      author: 'Suraj Kumar sah',
      excerpt: 'Practical tips and strategies for optimizing database performance in production environments.',
      content: 'Database performance is critical for application success. Explore indexing strategies, query optimization, and caching mechanisms that can significantly improve your application\'s performance.',
      image: '🗄️'
    },
    {
      id: 7,
      title: 'DevOps Best Practices: CI/CD Pipeline Setup',
      category: 'Technology',
      date: 'February 15, 2024',
      author: 'Suraj Kumar sah',
      excerpt: 'Setting up effective continuous integration and deployment pipelines for modern applications.',
      content: 'Continuous Integration and Continuous Deployment are essential practices in modern software development. Learn how to set up robust CI/CD pipelines that ensure code quality and faster deployment cycles.',
      image: '⚙️'
    },
    {
      id: 8,
      title: 'Personal Growth: The Importance of Continuous Learning',
      category: 'Entrepreneurship',
      date: 'February 10, 2024',
      author: 'Suraj Kumar sah',
      excerpt: 'Why continuous learning is essential for success in the tech industry.',
      content: 'Technology evolves rapidly, and staying relevant requires constant learning. Discover the resources, strategies, and mindset needed to keep your skills sharp and stay ahead in the industry.',
      image: '📚'
    },
    {
      id: 9,
      title: 'API Design Patterns for Scalable Services',
      category: 'Technology',
      date: 'February 5, 2024',
      author: 'Suraj Kumar sah',
      excerpt: 'Best practices and design patterns for building scalable and maintainable APIs.',
      content: 'Building well-designed APIs is crucial for creating scalable services. Learn about RESTful design principles, versioning strategies, and rate limiting to create robust APIs.',
      image: '🔌'
    }
  ];

  const categories = ['All', 'Technology', 'Mobile', 'Cloud', 'AI', 'Database', 'Entrepreneurship'];
  const filteredBlogs = selectedCategory === 'All'
    ? blogs
    : blogs.filter(blog => blog.category === selectedCategory);

  return (
    <motion.div
      className="blog"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <motion.div
          className="blog-header"
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <h2>My Blog</h2>
          <p>Thoughts, insights, and learnings about technology and entrepreneurship</p>
        </motion.div>

        <motion.div
          className="blog-filters"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-btn ${selectedCategory === cat ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </motion.div>

        <div className="blog-grid">
          {filteredBlogs.map((blog, index) => (
            <motion.article
              key={blog.id}
              className="blog-card"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -5 }}
              layout
            >
              <div className="blog-image">{blog.image}</div>
              <div className="blog-content">
                <span className="blog-category">{blog.category}</span>
                <h3>{blog.title}</h3>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <div className="blog-meta">
                  <span className="blog-date">{blog.date}</span>
                  <span className="blog-author">by {blog.author}</span>
                </div>
                <button
                  type="button"
                  className="read-more"
                  onClick={() => window.alert('Read More page not configured yet.')}
                >
                  Read More →
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Blog;